import { FC, useEffect, useRef, useState } from 'react';
import ProjectImage from '../ProjectImage/ProjectImage';
import { Image } from '@valbuild/next';

export interface ProjectImageModuleProps {
  images: Image[];
}

const ProjectImageModule: FC<ProjectImageModuleProps> = ({ images }) => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const currentImageVal = (scrollProgress * images.length) / 100;

  useEffect(() => {
    const element = containerRef.current;
    if (!element) {
      return;
    }

    const onScroll = () => {
      let windowScroll = element.scrollLeft;
      let totalWidth = element.scrollWidth - element.clientWidth;

      if (windowScroll > totalWidth) {
        return setScrollProgress(100);
      }

      setScrollProgress((windowScroll / totalWidth) * 100);
    };

    element.addEventListener('scroll', onScroll, {
      passive: true,
    });

    return () => element.removeEventListener('scroll', onScroll);
  }, [containerRef]);

  if (images.length === 1) {
    return (
      <ProjectImage
        src={images[0]}
        alt="projectImage"
        width={1280}
        height={720}
      />
    );
  }

  return (
    <div className="laptop:w-[1280px]">
      <div
        ref={containerRef}
        className="snap-mandatory snap-x flex mx-[-24px] laptop:mx-0 laptop:max-w-[1280px] laptop:flex-col flex-nowrap overflow-x-auto laptop:overflow-visible h-[447px] tablet:h-[800px] laptop:h-max scrollbar-hidden"
      >
        <div className="laptop:hidden min-w-[25vw] h-[327px]" />
        {images.map((image, idx) => {
          return (
            <div
              key={idx}
              className={`snap-center flex flex-[0_0_auto] w-[327px] h-[327px] tablet:w-[480px] tablet:h-[480px] laptop:block laptop:w-auto laptop:h-full ${
                idx % 2 !== 0 && 'self-end'
              } ${idx !== 0 && 'ml-[-24px] laptop:ml-0 laptop:mt-[-68px]'}`}
            >
              <ProjectImage
                src={image}
                alt={`projectImage${idx}`}
                width={741}
                height={480}
              />
            </div>
          );
        })}
        <div className="laptop:hidden min-w-[327px] h-[327px]" />
      </div>
      <div className="mt-24 flex space-x-[6.63px] laptop:hidden">
        {[...Array(images.length)].map((_, idx) => (
          <div
            key={idx}
            className={`h-16 w-16 ${
              currentImageVal >= idx && currentImageVal <= idx + 1
                ? 'bg-blank-black'
                : 'bg-black'
            } rotate-45`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectImageModule;
